import React from 'react';
import CloudUpload from '@material-ui/icons/CloudUpload';
import { IconButton } from '@material-ui/core';
import { CloudDownload } from '@material-ui/icons';
import './styles/_uploadFile.scss';

const UploadFile = (props) => {
	const { title: mainTitl, id, name, download, typeDownload, disabled, loader } = props;

	const _getName = (name) => {
		if (!name) return 'Subir Archivo';
		return name.length > 28 ? name.substring(0, 30) + ' ...' : name;
	};
	return (
		<div className="container-upload-file">
			<div className="subcontainer-upload-file">
				<label>{mainTitl || ''}</label>
			</div>
			<div className="subcontainer-buttons-upload-file">
				<label className="label-input-file-active" htmlFor={id}>
					<IconButton
						component="span"
						aria-label="search"
						className={disabled ? 'd-none' : 'label-input-file-active-icon'}
						style={{ color: '#FFFFFF' }}
					>
						<CloudUpload fontSize="large" />
					</IconButton>
				</label>
				<div className="label-input-file-active">
					<IconButton
						onClick={download}
						typeDownload={typeDownload}
						component="span"
						aria-label="search"
						className={
							name !== '' ? 'label-input-file-active-icon' : 'd-none'
						}
						style={{ color: '#FFFFFF' }}
					>
						{loader ? (
							<span
								style={{ paddingLeft: '15px' }}
								className="ml-3 spinner spinner-white"
							></span>
						) : (
							<CloudDownload fontSize="large" />
						)}
					</IconButton>
				</div>
				<label style={{ width: '60%' }} className="title-name-file">
					{_getName(name)}
				</label>
			</div>
			<input type="file" id={id} hidden />
		</div>
	);
};

export default UploadFile;
